import React from 'react'
import PageBody from '../../components/pagebody/PageBody'
import { Route, Routes } from 'react-router-dom'
import Xero from './integrations/xero/Xero'
import FreshBooks from './integrations/freshbooks/FreshBooks'
import IntegrationPagesView from './IntegrationPagesView'
import Qbo from './integrations/qbo/Qbo'
import SageIntacct from './integrations/sageintacct/SageIntacct'
import NetSuite from './integrations/netsuite/NetSuite'
import Qbd from './integrations/qbd/Qbd'
import Zoho from './integrations/zoho/Zoho'
import Tipalti from './integrations/tipalti/Tipalti'
import Bill from './integrations/bill/Bill'
import Entrata from './integrations/entrata/Entrata'
import AccountingSuite from './integrations/accountingsuite/AccoutingSuite'

export default function ImportSection() {

    return (
        <PageBody>
            <Routes>
                <Route path="/xero/*" element={<Xero />} />
                <Route path="/freshbooks/*" element={<FreshBooks />} />
                <Route path="/qbo/*" element={<Qbo />} />
                <Route path="/sageintacct/*" element={<SageIntacct />} />
                <Route path="/netsuite/*" element={<NetSuite />} />
                <Route path="/qbd/*" element={<Qbd />} />
                <Route path="/zoho/*" element={<Zoho />} />
                <Route path="/tipalti/*" element={<Tipalti />} />
                <Route path="/bill/*" element={<Bill />} />
                <Route path="/entrata/*" element={<Entrata />}/>
                <Route path="/accountingsuite/*" element={<AccountingSuite />} />
                <Route path="/*" element={<IntegrationPagesView />} />
            </Routes>
        </PageBody>
    )
}